module.exports = __webpack_public_path__ + "img/M-OFF-11.e11475b9.gif";